import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Header from "../../components/Header";
import BgImage from "../../components/BgImage";
import { countIssues } from "../../actions/issue";
import { Doughnut } from "react-chartjs-2";

const StatisticsByEmlpoyment = ({ countIssues }) => {
  const [employeesCounts, setEmployeesCounts] = useState([0, 0]);
  const state = {
    labels: ["у радном односу", "Није у радном односу"],
    datasets: [
      {
        label: "Rainfall",
        backgroundColor: ["#00408A", "#db3e3e"],
        hoverBackgroundColor: ["#002857", "#c22424"],
        data: employeesCounts,
      },
    ],
  };

  useEffect(() => {
    statsByEmployees();
  }, []);

  const statsByEmployees = async () => {
    let employed = await countIssues({ "reporter.employed": true });
    let unemployed = await countIssues({ "reporter.employed": false });
    setEmployeesCounts([employed, unemployed]);
  };

  return (
    <>
      <Header></Header>
      <BgImage></BgImage>
      <div className="container mx-auto">
        <div className="text-2xl text-center mt-10 uppercase">
          Статистика о запосленима
        </div>
        <Doughnut
          data={state}
          options={{
            legend: {
              display: true,
              position: "top",
            },
          }}
        />
      </div>
    </>
  );
};

const mapDispatchToProps = {
  countIssues,
};

export default connect(null, mapDispatchToProps)(StatisticsByEmlpoyment);
